import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.482 3.523c2.695-2.302 6.16-1.888 8.51.15 2.348-2.04 5.777-2.423 8.501-.16 2.989 2.485 3.347 6.721 1.046 9.682-.874 1.125-2.58 2.814-4.216 4.359a185 185 0 0 1-4.123 3.761c-.078.07-.182.163-.281.238a1.5 1.5 0 0 1-.487.253 1.54 1.54 0 0 1-.877 0 1.5 1.5 0 0 1-.488-.253c-.099-.075-.202-.168-.28-.238a185 185 0 0 1-4.124-3.761c-1.636-1.545-3.341-3.233-4.216-4.359C.137 10.223.562 6.02 3.482 3.523m7.725 2.286c-1.695-1.982-4.384-2.418-6.38-.712-2.09 1.785-2.37 4.739-.746 6.829.761.98 2.35 2.563 4.003 4.123a181 181 0 0 0 3.91 3.568c.851-.756 2.38-2.126 3.908-3.568 1.653-1.56 3.242-3.144 4.003-4.123 1.634-2.102 1.372-5.068-.735-6.82-2.05-1.703-4.704-1.27-6.39.703a1.035 1.035 0 0 1-1.573 0"
}));
export default SvgHeart;
//# sourceMappingURL=Heart.js.map